// ═══════════════════════════════════════════════════════════════════
//  modules/chat/SujRecaps.js
//  les récapitulatifs global et quotidien
//
//  Sorti de SujPanel.js le 7 aout 2026. Le JSX est celui d'origine,
//  deplace au caractere pres ; les props sont calculees par analyse
//  de portee, pas devinees.
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";
import { SujPuces } from "./SujPuces";
import { sujDateCourte, sujJourLong } from "./utils";

export function SujRecaps({ canRun, carte, isMobile, joursRecap, recapJour, rg, rq, setRecapJour }) {
  return (
    <>
      {/* ── 1. RÉCAPS ──────────────────────────────────────────────── */}
      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1.25fr 1fr", gap: 14 }}>

        {/* Récap global */}
        <div style={{ ...carte(`${THEME.purple}55`), background: `linear-gradient(155deg, ${THEME.purpleDim}, ${THEME.panel} 62%)` }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
            <div style={{ color: THEME.purple, fontSize: 12, fontWeight: 700, letterSpacing: 0.6, textTransform: "uppercase" }}>🧭 Récap global</div>
            {rg && <span style={{ marginLeft: "auto", color: THEME.textDim, fontSize: 10 }}>
              {rg.base_jours ? `${rg.base_jours} jour(s) analysés · ` : ""}maj {sujDateCourte(rg.created_at)}
            </span>}
          </div>
          {!rg ? (
            <div style={{ color: THEME.textDim, fontSize: 12, lineHeight: 1.5 }}>
              Pas encore de synthèse de fond. Elle est produite chaque nuit à partir des récaps quotidiens
              {canRun ? " — le bouton « Régénérer les récaps » en bas de page la crée immédiatement." : "."}
            </div>
          ) : (
            <>
              <div style={{ color: THEME.text, fontSize: 13, lineHeight: 1.6, whiteSpace: "pre-wrap" }}>{rg.recap || "—"}</div>
              <SujPuces titre="Priorités" items={rg.priorites} color={THEME.amber} puce="▸" />
              <SujPuces titre="Tendances de fond" items={rg.tendances_de_fond} color={THEME.text} puce="·" />
              <SujPuces titre="Signaux positifs" items={rg.signaux_positifs} color={THEME.emerald} puce="✓" />
            </>
          )}
        </div>

        {/* Récap quotidien */}
        <div style={carte()}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
            <div style={{ color: THEME.gold, fontSize: 12, fontWeight: 700, letterSpacing: 0.6, textTransform: "uppercase" }}>📅 Récap quotidien</div>
            {joursRecap.length > 0 && (
              <select value={recapJour || (rq ? rq.jour : "")} onChange={(e) => setRecapJour(e.target.value)}
                style={{ marginLeft: "auto", background: THEME.surface, border: `1px solid ${THEME.border}`, color: THEME.text, borderRadius: 6, padding: "4px 8px", fontSize: 11, outline: "none" }}>
                {joursRecap.map((j) => <option key={j} value={j}>{j}</option>)}
              </select>
            )}
          </div>
          {!rq ? (
            <div style={{ color: THEME.textDim, fontSize: 12, lineHeight: 1.5 }}>
              Aucun récap quotidien pour l'instant. Il est généré automatiquement au passage qui clôt la journée (minuit).
            </div>
          ) : (
            <>
              <div style={{ color: THEME.textMuted, fontSize: 11, textTransform: "capitalize", marginBottom: 6 }}>
                {sujJourLong(rq.jour)}{rq.nb_messages ? ` · ${rq.nb_messages} message(s)` : ""}
              </div>
              <div style={{ color: THEME.text, fontSize: 13, lineHeight: 1.6, whiteSpace: "pre-wrap" }}>{rq.recap || "—"}</div>
              <SujPuces titre="Faits marquants" items={rq.faits_marquants} color={THEME.text} puce="•" />
              {rq.vie_communaute && (
                <div style={{ marginTop: 10, background: THEME.surface, borderLeft: `3px solid #6FD3C7`, borderRadius: 6, padding: "8px 12px", color: THEME.textMuted, fontSize: 12, lineHeight: 1.5 }}>
                  🤝 {rq.vie_communaute}
                </div>
              )}
              <SujPuces titre="À surveiller" items={rq.a_surveiller} color={THEME.amber} puce="⚠" />
            </>
          )}
        </div>
      </div>
    </>
  );
}
